import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20editorial%20flat%20lay%20of%20diverse%20fashion%20products%20including%20colorful%20sneakers%20neon%20accents%20trendy%20streetwear%20accessories%20and%20tech%20gadgets%20arranged%20on%20clean%20white%20marble%20surface%20with%20tropical%20monstera%20leaves%2C%20bright%20natural%20sunlight%20streaming%20from%20window%2C%20bold%20contemporary%20e-commerce%20photography%2C%20lively%20energetic%20composition%20with%20pops%20of%20coral%20yellow%20and%20teal%20against%20crisp%20white%20background%2C%20high%20end%20product%20styling&width=1800&height=1000&seq=hero-yoybuy-v2&orientation=landscape"
          alt="YOYBUY Spreadsheet fashion products collage"
          title="YOYBUY Spreadsheet товары из Китая"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6 py-20 md:py-24 text-center">
        <div className="max-w-3xl mx-auto">
          <span className="inline-block px-4 py-1.5 mb-6 text-xs font-semibold tracking-widest uppercase text-background-50/90 bg-background-950/20 backdrop-blur-sm rounded-full border border-background-50/20">
            Заказ товаров из Китая
          </span>

          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-5">
            YOYBUY Spreadsheet — самый удобный способ заказывать товары из Китая
          </h1>

          <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-8 max-w-2xl mx-auto">
            Покупайте с Taobao, 1688 и других китайских платформ через простую таблицу.
            Без ошибок, без сложностей, с полной прозрачностью заказов.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 text-base font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-all duration-300 whitespace-nowrap no-underline"
            >
              Начать использовать YOYBUY Spreadsheet
              <i className="ri-arrow-right-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 text-base font-semibold text-background-50 bg-background-950/30 backdrop-blur-sm border border-background-50/30 hover:bg-background-950/50 rounded-full transition-all duration-300 whitespace-nowrap no-underline"
            >
              Перейти к заказу через YOYBUY
              <i className="ri-shopping-bag-line text-lg w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}